module.exports = __webpack_public_path__ + "static/media/ic_informacion.e6336104.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_informacion.webp
// module id = 172
// module chunks = 1